import { Box, Typography } from "@mui/material";
import * as styles from "./heroStyles";
import { HeroSettings } from "../../types/Settings";

const DEFAULT_TEXT = "Scannen, entdecken, erleben.\nExclusive Services am Spieltag";
const DEFAULT_SPONSOR_IMAGE = {
    url: "/images/illustrations/Praesentiert-NXP-Wempe_trimmed.svg",
    alt: "Gesponsort von NXP",
};

interface HeroProps {
    hero?: HeroSettings;
}

// Shows the default text and sponsor image until the CMS settings are loaded or when nothing is set there
const Hero: React.FC<HeroProps> = ({ hero }) => {
    const text = hero?.text.trim() ? hero.text : DEFAULT_TEXT;
    const sponsorImage = hero?.sponsorImageUrl
        ? {
              url: hero.sponsorImageUrl,
              alt: hero.sponsorAlt || DEFAULT_SPONSOR_IMAGE.alt,
          }
        : DEFAULT_SPONSOR_IMAGE;

    return (
        <Box sx={styles.heroContainer}>
            <Box sx={styles.serviceHubImageContainer}>
                <Box
                    component="img"
                    sx={styles.serviceHubImage}
                    src="/images/illustrations/vip-service-hub.svg"
                    alt="VIP Service Hub"
                />
            </Box>

            <Box>
                <Typography variant="h5" sx={styles.heroText}>
                    {text}
                </Typography>

                <Box
                    component="img"
                    sx={styles.sponsorImage}
                    src={sponsorImage.url}
                    alt={sponsorImage.alt}
                />
            </Box>
        </Box>
    );
};

export default Hero;
